import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function AdminAuditLogPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit-log?limit=500").then(r => setItems(r.data || [])).catch(() => toast.error("Owner-only")); }, []);
  return (
    <AdminLayout>
      <div className="kicker">Owner only</div>
      <h1 className="mt-1 font-serif text-3xl font-semibold">Audit log</h1>
      <Card className="mt-6 p-0 overflow-hidden">
        <table className="w-full text-sm admin-table">
          <thead className="bg-secondary border-b border-border">
            <tr>
              <th className="px-4 py-3 text-left">When</th>
              <th className="px-4 py-3 text-left">Actor</th>
              <th className="px-4 py-3 text-left">Action</th>
              <th className="px-4 py-3 text-left">Table</th>
              <th className="px-4 py-3 text-left">Record</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center text-muted-foreground">No events yet.</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-b border-border last:border-b-0">
                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(a.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-xs font-mono">{a.actor_id?.slice(0,8) || "—"}</td>
                <td className="px-4 py-3">{a.action}</td>
                <td className="px-4 py-3">{a.table_name}</td>
                <td className="px-4 py-3 text-xs font-mono">{a.record_id?.slice(0,8) || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </AdminLayout>
  );
}
